import React from 'react'
import './style.css'
import { withRouter } from 'react-router-dom'
import data from './data.json'
import { notification } from 'antd'

function SatelliteSystem(props) {

    const developingSatelite = new Set([16, 18, 21, 23]);//正在建设中的卫星的索引

    function handleSateliteDetail(index) {
        if (developingSatelite.has(index)) {
            //是否提示当前卫星正在建设中
            notification.info({
                message: '提示',
                description: '当前卫星正在建设中',
                placement: 'topRight',
            });
        } else {
            props.history.push({
                pathname: '/Introduce/SateliteDetail',
                search: `?id=${index}&selectMenuIndex=${1}`
            });
        }
    }

    const images = require.context('../../../img', true);

    function buildTwelveSatelite(start, end) {
        let twelveSatelites = [];
        for (let i = start; i < end; i++) {
            let curData = data[i];
            let imageUrl = curData.image;
            const image = images(`./${imageUrl}`);
            twelveSatelites.push(
                <div key={i} className='Home_Satelite_Item' onClick={() => handleSateliteDetail(i)}>
                    <div className='Satelite_image_Container'>
                        <img className='Satelite_image' src={image} alt={"正在加载图片"}>
                        </img>
                        <div className='Satelite_Type'>{curData.sateliteType}</div>
                    </div>
                    <div className='Satelite_Text'>
                        <div className='Satelite_Title'>{curData.name}</div>
                        <div className='Satelite_Id'>{curData.id}</div>
                        <div className='Satelite_Date_Line'>
                            {!developingSatelite.has(i) ?
                                <svg className='Launch_Icon' viewBox="0 0 20 21" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_4788_30028)">
                                        <path
                                            d="M7.98268 6.13882C8.10009 6.09965 8.22609 6.09394 8.34657 6.12233C8.46704 6.15072 8.57723 6.21209 8.6648 6.29957L14.6818 12.3166C14.7693 12.4041 14.8307 12.5143 14.859 12.6348C14.8874 12.7553 14.8817 12.8813 14.8426 12.9987L13.2982 17.6326C13.2263 17.8482 13.1004 18.0419 12.9326 18.1952C12.7648 18.3485 12.5605 18.4563 12.3393 18.5084C12.1181 18.5606 11.8872 18.5553 11.6685 18.4931C11.4499 18.4309 11.2508 18.3138 11.0902 18.153L2.82834 9.8912C2.66766 9.73051 2.55072 9.53141 2.48861 9.31282C2.4265 9.09423 2.4213 8.86339 2.47349 8.64222C2.52567 8.42104 2.63352 8.21688 2.7868 8.04911C2.94007 7.88134 3.13368 7.75552 3.34924 7.68361L7.98315 6.13929L7.98268 6.13882ZM1.77381 10.7223C1.89883 10.5973 2.0684 10.527 2.24521 10.527C2.42202 10.527 2.59159 10.5973 2.71662 10.7223C2.84164 10.8473 2.91188 11.0169 2.91188 11.1937C2.91188 11.3705 2.84164 11.5401 2.71662 11.6651L2.24521 12.1365C2.12019 12.2615 1.95062 12.3318 1.77381 12.3318C1.597 12.3318 1.42743 12.2615 1.30241 12.1365C1.17738 12.0115 1.10714 11.8419 1.10714 11.6651C1.10714 11.4883 1.17738 11.3187 1.30241 11.1937L1.77381 10.7223ZM10.2591 18.2648C10.1972 18.2028 10.1237 18.1537 10.0428 18.1202C9.96192 18.0867 9.87523 18.0695 9.78768 18.0695C9.70014 18.0695 9.61345 18.0867 9.53256 18.1202C9.45168 18.1537 9.37819 18.2028 9.31628 18.2648L8.84488 18.7362C8.71985 18.8612 8.64961 19.0308 8.64961 19.2076C8.64961 19.3844 8.71985 19.5539 8.84488 19.679C8.9699 19.804 9.13947 19.8742 9.31628 19.8742C9.49309 19.8742 9.66266 19.804 9.78769 19.679L10.2591 19.2076C10.321 19.1457 10.3701 19.0722 10.4036 18.9913C10.4371 18.9104 10.4544 18.8237 10.4544 18.7362C10.4544 18.6486 10.4371 18.5619 10.4036 18.481C10.3701 18.4002 10.321 18.3267 10.2591 18.2648Z"
                                            fill="#53A9FF" />
                                        <path fillRule="evenodd" clipRule="evenodd"
                                            d="M11.4341 3.8092C10.5321 4.1429 9.71299 4.6678 9.03297 5.34789L5.07317 9.30769C4.198 10.1829 3.70634 11.3698 3.70634 12.6075C3.70634 13.8452 4.198 15.0322 5.07317 15.9073C5.94834 16.7825 7.13533 17.2742 8.373 17.2742C9.61068 17.2742 10.7977 16.7825 11.6728 15.9073L15.6331 11.9471C16.313 11.2671 16.8378 10.448 17.1714 9.54612C17.5051 8.64422 17.6396 7.68082 17.5659 6.72203L17.374 4.22029C17.3618 4.06155 17.2933 3.91241 17.1807 3.79983C17.0681 3.68726 16.919 3.61869 16.7602 3.60652L14.2585 3.41466C13.2996 3.34091 12.3361 3.4755 11.4341 3.8092ZM15.0872 7.89329C15.0872 7.36285 14.8765 6.85415 14.5014 6.47907C14.1263 6.104 13.6176 5.89329 13.0872 5.89329C12.5567 5.89329 12.048 6.104 11.673 6.47907C11.2979 6.85415 11.0872 7.36285 11.0872 7.89329C11.0872 8.42372 11.2979 8.93243 11.673 9.3075C12.048 9.68257 12.5567 9.89329 13.0872 9.89329C13.6176 9.89329 14.1263 9.68257 14.5014 9.3075C14.8765 8.93243 15.0872 8.42372 15.0872 7.89329Z"
                                            fill="#0072E5" />
                                        <path
                                            d="M6.48758 13.5515C6.54949 13.4896 6.62298 13.4405 6.70386 13.407C6.78475 13.3735 6.87144 13.3562 6.95898 13.3562C7.04653 13.3562 7.13322 13.3735 7.21411 13.407C7.29499 13.4405 7.36848 13.4896 7.43039 13.5515C7.49229 13.6134 7.5414 13.6869 7.5749 13.7678C7.60841 13.8486 7.62565 13.9353 7.62565 14.0229C7.62565 14.1104 7.60841 14.1971 7.5749 14.278C7.5414 14.3589 7.49229 14.4324 7.43039 14.4943L5.54477 16.3799C5.48287 16.4418 5.40937 16.4909 5.32849 16.5244C5.2476 16.5579 5.16091 16.5752 5.07337 16.5752C4.98582 16.5752 4.89913 16.5579 4.81824 16.5244C4.73736 16.4909 4.66387 16.4418 4.60196 16.3799C4.54006 16.318 4.49095 16.2445 4.45745 16.1636C4.42394 16.0827 4.4067 15.9961 4.4067 15.9085C4.4067 15.821 4.42394 15.7343 4.45745 15.6534C4.49095 15.5725 4.54006 15.499 4.60196 15.4371L6.48758 13.5515Z"
                                            fill="#53A9FF" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4788_30028">
                                            <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
                                        </clipPath>
                                    </defs>
                                </svg> : null}
                            <div className='Satelite_Date'>{curData.transmissionTime}</div>
                        </div>
                    </div>
                </div>);
        }
        return twelveSatelites;
    }


    return (
        <div className='SatelliteSystem_Container'>

            <div className='Home_Satelite_Title'>
                空基卫星
            </div>
            <div className='Home_Satelite_Body'>
                <div className='Home_Twelve_Block '>
                    {/* 十二五卫星群组 */}
                    <div className='Group_Title_Line'>
                        <div className='Line'></div>
                        <div className='Home_TiTle_Item'>十二五卫星</div>
                        <div className='Line'></div>
                    </div>
                    <div className='Satelites_Containe'>
                        {buildTwelveSatelite(0, 9)}
                    </div>
                    {/* 十三五卫星群组 */}
                    <div className='Group_Title_Line'>
                        <div className='Line'></div>
                        <div className='Home_TiTle_Item'>十三五卫星</div>
                        <div className='Line'></div>
                    </div>
                    <div className='Satelites_Containe'>
                        {buildTwelveSatelite(9, 24)}
                    </div>
                    <div className='Group_Title_Line'>
                        <div className='Line'></div>
                        <div className='Home_TiTle_Item'>其它</div>
                        <div className='Line'></div>
                    </div>
                    <div className='Satelites_Containe'>
                        {buildTwelveSatelite(24, 42)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(SatelliteSystem)